<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="560px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #fff" class="text-h5">Solicitar Autorização</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(confirmar)">
                <v-row class="pt-4">
                  <v-col class="pt-0 pb-0" cols="12">
                    <e-label class="font-weight-medium">Etapa</e-label>
                    <p class="font-weight-regular">{{ etapaDescricao || "Não informada" }}</p>
                  </v-col>
                  <v-col class="pt-0 pb-0" cols="12">
                    <e-label class="font-weight-medium">Tipo de solicitação</e-label>
                    <p class="font-weight-regular">{{ tipoDescricao }}</p>
                  </v-col>
                  <v-col class="pt-0 pb-0" cols="12">
                    <ValidationProvider name="Motivo" rules="required|min:5" v-slot="{ errors }">
                      <e-label>
                        Motivo da Solicitação
                        <span class="red--text">*</span>
                      </e-label>
                      <v-textarea
                        v-model="observacoes"
                        solo
                        dense
                        :error-messages="errors"
                        placeholder="Descreva o motivo pelo qual precisa lançar fora do período..."
                        rows="3"
                        counter="1000"
                        maxlength="1000"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    type="button"
                    :disabled="salvando"
                    @click="fechar"
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    style="color: #fff"
                    class="green darken-1"
                    type="submit"
                    :loading="salvando"
                    :disabled="salvando"
                  >
                    Enviar Solicitação
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import ELabel from "@/components/ELabel.vue";
import store from "@/store";

export default {
  name: "EModalSolicitarAutorizacao",

  components: { ELabel },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    etapaId: {
      type: Number,
      default: null,
    },
    etapaDescricao: {
      type: String,
      default: "",
    },
    tipo: {
      type: String,
      default: "aula",
      validator: (v) => ["aula", "nota"].includes(v),
    },
    instrutorId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      observacoes: "",
      salvando: false,
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    tipoDescricao() {
      return this.tipo === "nota" ? "LANÇAR NOTAS FORA DO PERÍODO" : "LANÇAR AULAS FORA DO PERÍODO";
    },
  },

  watch: {
    value(val) {
      if (!val) {
        this.observacoes = "";
        if (this.$refs.obs) this.$refs.obs.reset();
      }
    },
  },

  methods: {
    fechar() {
      this.observacoes = "";
      if (this.$refs.obs) this.$refs.obs.reset();
      this.dialog = false;
    },

    async confirmar() {
      const valid = await this.$refs.obs.validate();
      if (!valid) return;

      this.salvando = true;
      const currentUser = store.getters["Auth/user"];
      const pedidoId = this.tipo === "nota" ? 2 : 1;

      try {
        await this.$services.autorizacoesService.criarAutorizacao({
          pedido_id: pedidoId,
          tipo: this.tipo,
          etapa_id: this.etapaId,
          user_solicitante: currentUser.id,
          instrutor_id: this.instrutorId,
          status: "PENDENTE",
          observacoes: this.observacoes,
          data: new Date().toISOString().split("T")[0],
        });

        this.$toast.success("Solicitação enviada com sucesso! Aguarde a análise.");
        this.$emit("solicitacaoEnviada");
        this.fechar();
      } catch (error) {
        if (error.response?.status === 409) {
          this.$toast.danger(
            "Já existe uma solicitação para esta etapa. Acompanhe o andamento dos seus pedidos."
          );
          this.$emit("solicitacaoDuplicada");
          this.fechar();
        } else {
          this.$handleError(error);
        }
      }

      this.salvando = false;
    },
  },
};
</script>
